<ui5-time-picker
  format-pattern="HH:mm:ss"
  #durationPicker readonly
  (change)="onDateTimeChange()"
  (click)="onDatePickerOpen()"
  [value]="duration"
  [disabled]="disabled">
</ui5-time-picker>
<div class="timer-icon" (click)="onDatePickerOpen()" [class.disabled]="disabled">
	<mat-icon svgIcon="timer" [matTooltip]="tooltip"></mat-icon>
</div>
